import { put } from 'redux-saga/effects';
import {
    fetchCompaniesFailure,
    fetchCompaniesSuccess,
    fetchInheritedCompaniesFailure,
    fetchInheritedCompaniesSuccess,
} from 'src/features/resources-assignment/slice';
import apiClient from 'src/services/apiClient';
import { getUrl } from 'src/services/ApiService';
import { RESOURCES_TYPES } from '../constants';
import { getFilterQueryString, getSortQueryString } from '../utils';
import axios from 'axios';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import { getTransformedSortModel } from '../components/Companies/util';

export const COMPANIES_API_CACHE_ID = 'cache:companies';

const getApiMetaData = (activeConnectedAppId, queryOptions, filterModel, sortModel) => {
    let endpoint = `/iambff/v1/connected-apps/${activeConnectedAppId}/corporate-structure/companies`;
    endpoint += `?limit=${queryOptions.limit}`;
    endpoint += queryOptions.cursor ? `&cursor=${queryOptions.cursor}` : '';

    let filterQueryString = getFilterQueryString(filterModel, RESOURCES_TYPES.COMPANY);
    if (filterQueryString) {
        endpoint += `&filter=${filterQueryString}`;
    }

    if (sortModel?.length) {
        const transformedSortModel = getTransformedSortModel(sortModel);
        const sortQueryString = getSortQueryString(transformedSortModel);
        if (sortQueryString) {
            endpoint += `&sortBy=${sortQueryString}`;
        }
    }

    return { endpoint, filterQueryString };
};

export function* getCompanies(action) {
    const { activeConnectedAppId, queryOptions, filterModel, sortModel, totalRowCount, signal } = action.payload;
    const { endpoint, filterQueryString } = getApiMetaData(activeConnectedAppId, queryOptions, filterModel, sortModel);

    try {
        const result = yield apiClient.get(getUrl(endpoint), {
            cache: {
                ttl: 1000 * 60 * 3, // 3 minute
                id: COMPANIES_API_CACHE_ID,
                cachePredicate: {
                    ignoreUrls: [/cursor/, /filter/], // Ignore cache when url contains cursor or filter
                },
            },
            signal,
        });
        const companyTotalCount = result.headers.get('x-user-companies-count');

        if (companyTotalCount === '') {
            const result = {
                isSuccess: false,
                error: formatMessage(Locale.companiesErrorStateCount),
            };
            yield put(fetchCompaniesFailure(result));
            return;
        }
        const nextCursor = result.headers.get('x-next-cursor');
        const pageInfo = {
            nextCursor,
            hasNextPage: !!nextCursor,
        };
        if (filterQueryString) {
            pageInfo.totalRowCount = totalRowCount;
            pageInfo.totalRowCountWithFilter = Number.parseInt(companyTotalCount);
        } else {
            pageInfo.totalRowCount = Number.parseInt(companyTotalCount);
            pageInfo.totalRowCountWithFilter = undefined;
        }
        yield put(
            fetchCompaniesSuccess({
                rows: result.data,
                pageInfo,
            })
        );
    } catch (error) {
        const { message } = error;
        if (axios.isCancel(error)) {
            return;
        }
        const result = {
            isSuccess: false,
            error: message,
        };
        yield put(fetchCompaniesFailure(result));
    }
}

export function* getInheritedCompanies(action) {
    const { activeConnectedAppId, queryOptions, filterModel, signal } = action.payload;
    const { endpoint } = getApiMetaData(activeConnectedAppId, queryOptions, filterModel);

    try {
        const result = yield apiClient.get(getUrl(endpoint), {
            cache: false,
            signal,
        });
        yield put(
            fetchInheritedCompaniesSuccess({
                rows: result.data,
            })
        );
    } catch (error) {
        const { message } = error;
        if (axios.isCancel(error)) {
            return;
        }
        yield put(
            fetchInheritedCompaniesFailure({
                error: message,
                isSuccess: false,
            })
        );
    }
}
